<template>
  <div class="combo-import-page">
    <h2 class="combo-title">套餐订单与组件</h2>
    <el-alert title="本页只读新套餐批次及供应商子单映射，发货/收货由独立供应商履约页完成。" type="info" :closable="false" />
    <div class="combo-toolbar"><el-input v-model="filters.batch_sn" placeholder="批次号" clearable style="width: 280px" @keyup.enter.native="search" /><el-button type="primary" :loading="loading" @click="search">查询</el-button></div>
    <el-table v-loading="loading" :data="orders" border>
      <el-table-column prop="trade_sn" label="交易号" min-width="240" />
      <el-table-column prop="batch_no" label="批次号" min-width="230" />
      <el-table-column label="套餐快照" min-width="220"><template slot-scope="scope">{{ scope.row.shop_combo_name || '普通商品' }}<span v-if="scope.row.combo_suite_num"> × {{ scope.row.combo_suite_num }}套</span></template></el-table-column>
      <el-table-column label="组件" min-width="260"><template slot-scope="scope"><div v-for="(item, itemIndex) in scope.row.items" :key="`${item.fulfillment_sn}-${itemIndex}`"><el-tag v-if="item.is_combo" size="mini" type="warning">套餐组件</el-tag>{{ item.name }} × {{ item.num }}</div></template></el-table-column>
      <el-table-column label="收货人" min-width="200"><template slot-scope="scope">{{ scope.row.addr_name }}<br>{{ scope.row.mobile }}</template></el-table-column>
      <el-table-column label="支付状态" width="110"><template slot-scope="scope">{{ scope.row.trade_status === 'PAID' ? '已支付' : scope.row.trade_status === 'CANCELLED' ? '已取消' : '待支付' }}</template></el-table-column>
      <el-table-column label="操作" width="110"><template slot-scope="scope"><el-button type="text" @click="$router.push({ name: 'comboImportBatchDetail', params: { batchSn: scope.row.batch_no } })">批次详情</el-button></template></el-table-column>
    </el-table>
    <el-pagination style="margin-top: 18px; text-align: right" background layout="total, sizes, prev, pager, next" :page-sizes="[10, 20, 50]" :total="total" :page-size="filters.page_size" :current-page="filters.page_no" @current-change="load" @size-change="changeSize" />
  </div>
</template>
<script>
import { getComboBatches, getComboBatch } from '@/api/comboImport'

export default {
  name: 'ComboImportOrderList',
  data () { return { loading: false, orders: [], total: 0, filters: { batch_sn: '', page_no: 1, page_size: 20 }, requestSeq: 0 } },
  mounted () { this.load(1) },
  methods: {
    // 分页按批次：data_total 为批次总数；翻页/改页大小/筛选共用同一组 filters 状态
    search () { return this.load(1) },
    changeSize (size) { this.filters.page_size = size; return this.load(1) },
    async load (page) {
      // 每次查询绑定独立请求序号，仅最新请求的响应允许写页面，过期响应不得覆盖当前页码/数据/错误与loading
      const requestId = ++this.requestSeq
      this.filters.page_no = page
      this.loading = true
      try {
        const response = await getComboBatches({ batch_sn: this.filters.batch_sn || undefined, page_no: this.filters.page_no, page_size: this.filters.page_size })
        if (requestId !== this.requestSeq) return
        this.total = response.data.data_total || 0
        const batches = await Promise.all((response.data.data || []).map(item => getComboBatch(item.batch_no)))
        if (requestId !== this.requestSeq) return
        this.orders = batches.flatMap(result => (result.data.normal_order || []).map(trade => ({
          trade_sn: trade.trade_sn,
          batch_no: result.data.batch_no,
          combo_id: trade.combo_id,
          shop_combo_name: trade.shop_combo_name,
          combo_suite_num: trade.combo_suite_num,
          addr_name: trade.addr_name,
          mobile: trade.mobile,
          trade_status: trade.trade_status,
          items: (trade.order_list || []).flatMap(order => (order.sku_list || []).map(item => ({ ...item, fulfillment_sn: order.fulfillment_sn, seller_name: order.seller_name })))
        })))
      } catch (e) {
        if (requestId !== this.requestSeq) return
        this.orders = []
        this.$message.error('查询失败，请稍后重试')
      } finally {
        if (requestId === this.requestSeq) this.loading = false
      }
    }
  }
}
</script>
<style src="./comboImport.css"></style>
